import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/projects';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async items(params: any) {
    return api.items(params);
  }

  @Action
  async agreement(params: any) {
    return api.agreement(params);
  }

  @Action
  async audit(params: any) {
    return api.audit(params);
  }

  @Action
  async logs(params: any) {
    return api.logs(params);
  }

  @Action
  async option(params: any) {
    return api.option(params);
  }

  @Action
  async saveUserName(params: any) {
    return api.saveUserName(params)
  }

  @Action
  async itemsoption(params: any) {
    return api.itemsoption(params)
  }
}
